export default __webpack_public_path__ + "9f7841c4a55d2ec056a4da5589c39180.svg";